export default __webpack_public_path__ + "static/media/WorldSteamBox.a27ea42f.svg";